/* eslint-disable react/no-unused-state */
import React from "react";
import { connect } from "react-redux";
import * as moment from "moment";
import { TableWrapper } from "../../../shared/layout";
import { templateStrings } from "../../../Constant";
import { dayWiseBreakDownCollectionListAction, breakDownCollectionSummaryAction } from "../../../redux/action-creators/dayWiseBreakDownActionCreator";
import { markLiveNoLiveAction } from "../../../redux/action-creators/collectionActionCreator";
import { setTokenExpired } from "../../../redux/actions/authActions";
import { setNotificationMessage } from "../../../redux/actions/notificationAction";
import EditContractPage from "./EditContractPage";

class BusDetailDayWiseList extends React.Component {
  constructor(props) {
    super(props);
    const m = moment(new Date());
    this.state = {
      showHeaderButton: true,
      pageNo: 0,
      showEditModal: false,
      contractDetails: {},
      isUserAViewer: false,
      date: m,
      todaySelectable: true,
      backdrop: false,
      content: [],
      rowsPerPage: 10,
      selected: [],
      selectedIds: {},
      selectedWaybillStatuses: {},
      waybillStatus: [],
      sortBy: {},
    };
    this.busDetailDayWiseGetList = this.busDetailDayWiseGetList.bind(this);
    this.closeEditModal = this.closeEditModal.bind(this);
    this.handleAction.bind(this);
    this.onSortToggle = this.onSortToggle.bind(this);
  }

  componentDidMount() {
    this.busDetailDayWiseGetList();
  }

  componentDidUpdate(prevProps) {
    const {
      fetchBusDetailSummary, cityFilter, busNumber, operatorFilter, selectedDateFilter, gridLoader,
    } = this.props;
    if (prevProps && prevProps.gridLoader && prevProps.gridLoader !== gridLoader) {
      this.busDetailDayWiseGetList();
      fetchBusDetailSummary({
        cityFilter,
        busNumber,
        operatorId: operatorFilter,
        dateFilter: selectedDateFilter,
      }, "collectionLoader");
      this.setState({ selected: [], selectedIds: {}, selectedWaybillStatuses: {} });
    }
    if (prevProps && (
      (prevProps.operatorFilter !== operatorFilter)
      || (prevProps.cityFilter !== cityFilter)
      || (prevProps.selectedDateFilter !== selectedDateFilter))) {
      this.busDetailDayWiseGetList();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  handleAction() {
    // eslint-disable-next-line no-console
    console.log("action clicked");
  }

  onSortToggle(value, key) {
    this.setState(
      {
        sortBy: { [key]: value },
      },
      () => {
        this.busDetailDayWiseGetList();
      },
    );
  }

  selectionID = (type, id = "") => {
    const { content } = this.props;
    const { selectedIds, selectedWaybillStatuses } = this.state;
    if (type === "selected") {
      const newSelected = {};
      const newSelectedWaybill = {};
      const data = content.find((elem) => {
        if (elem.uniqueKey === id) {
          return elem;
        }
        return null;
      });
      newSelected[id] = !!data.contract.length;
      newSelectedWaybill[id] = data.waybillStatus;
      this.setState({
        selectedIds: { ...selectedIds, ...newSelected },
        selectedWaybillStatuses: { ...selectedWaybillStatuses, ...newSelectedWaybill },
      });
    } else if (type === "removed") {
      const removed = { ...selectedIds };
      const removedWaybills = { ...selectedWaybillStatuses };
      delete removedWaybills[id];
      delete removed[id];
      this.setState({ selectedIds: removed, selectedWaybillStatuses: removedWaybills });
    } else if (type === "all") {
      const newSelected = {};
      const newSelectedWaybill = {};
      content.forEach((element) => {
        newSelected[element.uniqueKey] = !!element.contract.length;
        newSelectedWaybill[element.uniqueKey] = element.waybillStatus;
      });
      this.setState({
        selectedIds: { ...selectedIds, ...newSelected },
        selectedWaybillStatuses: { ...selectedWaybillStatuses, ...newSelectedWaybill },
      });
    } else if (type === "clear") {
      this.setState({ selectedIds: {}, selectedWaybillStatuses: {} });
    }
  };

  checkLiveNoLive = () => {
    const { selectedIds, selectedWaybillStatuses } = this.state;
    const data = Object.keys(selectedIds).map((key) => selectedIds[key]);
    const waybillData = Object.keys(selectedWaybillStatuses).map((
      key,
    ) => selectedWaybillStatuses[key]);
    if (data.includes(false) && data.includes(true)) {
      return "error";
    }
    if (data.includes(true) && data.length > 1) {
      return "multiple_live";
    }
    if (waybillData.includes("running") || waybillData.includes("Running")) {
      return "running_waybill";
    }
    if (data.includes(true)) {
      return true;
    }
    if (data.includes(false)) {
      return false;
    }
    return null;
  };

  handleChange = (input, value) => {
    this.setState({ [input]: value }, () => {
      if (input === "pageNo") {
        this.setState({ selected: [] });
        this.busDetailDayWiseGetList();
      }
    });
  };

  onMarkClicked = () => {
    const { markCollection } = this.props;
    const { selectedMarkOption, selectedArray } = this.state;
    markCollection({
      markOption: selectedMarkOption,
      selectedData: selectedArray,
    }, "gridLoader");
  };

  handleMarkClick = (option, selectedData) => {
    const { content } = this.props;
    if (option === "No Live") {
      this.setState({
        contractDetails: content.find((item) => item.uniqueKey === selectedData[0]),
      });
      this.setState({ showEditModal: true });
      return;
    }
    const selectedArray = content.filter((vehicle) => selectedData.includes(vehicle.uniqueKey));
    this.setState(
      {
        selectedMarkOption: option,
        selectedArray: selectedArray.map(
          (val) => ({ _id: val.uniqueKey, operatorId: val.operatorId, settled: val.settled }),
        ),
      },
      () => {
        this.onMarkClicked();
      },
    );
  };

  closeEditModal() {
    this.setState({
      showEditModal: false,
    });
  }

  /**
   * API call to get data.
   * @param pageNo current page number
   */
  busDetailDayWiseGetList() {
    const {
      fetchDayWiseBreakDown, busNumber,
      selectedDateFilter, selectedOperation, operatorFilter, cityFilter,
    } = this.props;
    const { pageNo, rowsPerPage, sortBy } = this.state;
    fetchDayWiseBreakDown({
      pageNo,
      pageSize: rowsPerPage,
      busNumber,
      dateFilter: selectedDateFilter,
      operationType: selectedOperation,
      operatorId: operatorFilter,
      cityId: cityFilter,
      sortBy,
    });
  }

  render() {
    const {
      headerLoader, gridLoader, content, totalItems,
    } = this.props;
    const {
      selected, pageNo, rowsPerPage, sortBy, showEditModal, contractDetails,
    } = this.state;
    return (
      <div>
        <TableWrapper
          content={!headerLoader && content}
          selected={selected}
          pageNo={pageNo}
          uniqueKey="uniqueKey"
          rowsPerPage={rowsPerPage}
          count={totalItems}
          handleChange={this.handleChange}
          templateString={templateStrings.busDetailDayWise}
          selectionAllowed
          markOption
          minWidth={200}
          handleMarkClick={this.handleMarkClick}
          handleAction={this.handleAction}
          onSortToggle={this.onSortToggle}
          sortBy={sortBy}
          gridLoader={gridLoader}
          selectionID={this.selectionID}
          checkLiveNoLive={this.checkLiveNoLive}
          paperClassName="position-relative"
          tableContainerClassName="day-wise-dues-collection"
        />
        {showEditModal
        && (
          <EditContractPage
            closeEditModal={this.closeEditModal}
            details={contractDetails}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    content:
      (state
        && state.BreakDown
        && state.BreakDown.dayWiseBreakDownCollection
        && state.BreakDown.dayWiseBreakDownCollection.items)
      || [],
    cityFilter: state.Cities.selectedCity,
    selectedDateFilter: state.DateFilter.selectedDateFilter,
    operatorFilter: state.Operators.selectedOperator,
    headerLoader: (state && state.loadingBar && state.loadingBar.header),
    selectedOperation: state.OperationType.selectedOperationType,
    totalItems:
      (state
        && state.BreakDown
        && state.BreakDown.dayWiseBreakDownCollection
        && state.BreakDown.dayWiseBreakDownCollection.totalItems)
      || 0,
    gridLoader: state && state.loadingBar && state.loadingBar.gridLoader,
  };
}

const mapDispatchToProps = (dispatch) => ({
  fetchDayWiseBreakDown: (params) => {
    dispatch(dayWiseBreakDownCollectionListAction(params));
  },
  markCollection: (params, loaderScope) => {
    dispatch(markLiveNoLiveAction(params, loaderScope));
  },
  initiateNotification: (value) => {
    dispatch(setNotificationMessage(value));
  },
  setTokenExpired: (value) => {
    dispatch(setTokenExpired(value));
  },
  fetchBusDetailSummary: (params, loaderScope) => {
    dispatch(breakDownCollectionSummaryAction(params, loaderScope));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(BusDetailDayWiseList);
